import { lazy } from 'react';

export const AffiliateCommissionsPageLazy = lazy(
    () => import('./affiliate-commissions-page'),
);
